import { useEffect } from 'react';

const GoogleTagManager = ({ containerId }) => {
  useEffect(() => {
    const isProd = import.meta.env.VITE_APP_ENV === 'production';
    const hasContainer = Boolean(containerId);

    if (!isProd || !hasContainer) {
      return undefined;
    }

    // avoid injecting duplicate scripts if already present
    const existingScript = document.head.querySelector(
      `script[src="https://www.googletagmanager.com/gtm.js?id=${containerId}"]`,
    );
    if (existingScript) {
      return undefined;
    }

    const dataLayerScript = document.createElement('script');
    dataLayerScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
    `;

    const gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=${containerId}"
        height="0"
        width="0"
        style="display:none;visibility:hidden"
      ></iframe>
    `;

    document.head.appendChild(dataLayerScript);
    document.head.appendChild(gtmScript);
    document.body.prepend(noscript);

    return () => {
      dataLayerScript.remove();
      gtmScript.remove();
      noscript.remove();
    };
  }, [containerId]);

  return null;
};

export default GoogleTagManager;
